module.exports = __webpack_public_path__ + "img/AI_PPT1.9867e3c2.png";